// http://osvaldas.info/elegant-css-and-jquery-tooltip-responsive-mobile-friendly
$(document).ready(function() {

    var SELECTOR_TOOLTIP = '[rel~=tooltip]'; //'.js-tooltip';
    var SELECTOR_DATATOOLTIP = '[data-tooltip]'; //'.js-tooltip';

    /**
     * Initialize the tooltip.
     *
     * @param $target The target element.
     * @param $tooltip The tooltip element.
     */
    var initializeTooltip = function ($target, $tooltip) {
        if ($(window).width() < ($tooltip.outerWidth() * 1.5)) {
            $tooltip.css('max-width', $(window).width() / 2);
        } else {
            $tooltip.css('max-width', 340);
        }

        var left = $target.offset().left + ($target.outerWidth() / 2) - ($tooltip.outerWidth() / 2);
        var top = $target.offset().top - $tooltip.outerHeight() - 20;
        if (left < 0) {
            left = $target.offset().left + $target.outerWidth() / 2 - 20;
            $tooltip.addClass('left');
        } else {
            $tooltip.removeClass('left');
        }

        if (left + $tooltip.outerWidth() > $(window).width()) {
            left = $target.offset().left - $tooltip.outerWidth() + $target.outerWidth() / 2 + 20;
            $tooltip.addClass('right');
        } else {
            $tooltip.removeClass('right');
        }

        if (top < 0) {
            top = $target.offset().top + $target.outerHeight();
            $tooltip.addClass('top');
        } else {
            $tooltip.removeClass('top');
        }

        $tooltip.css({ left: left, top: top }).animate({ top: '+=10', opacity: 1 }, 50);
    };

    /**
     * Parse all tooltips and remove the indicator to prevent re-parsing.
     */
    var parseTooltip = function () {
        $(SELECTOR_TOOLTIP).each(function (index, element) {
            var $target = false;
            var $tooltip = false;
            var tip = false;
            var $container = $(element);
            $container.removeClass(SELECTOR_TOOLTIP);
            $container.mouseenter(function () {
                $target = $(this);
                tip = $target.attr('title');
                $tooltip = $('<div class="tooltip"></div>');
                if (!tip || (tip === '')) return false;
                $target.removeAttr('title');
                $tooltip.css('opacity', 0).html(tip).appendTo('body');
                initializeTooltip($target, $tooltip);
                $(window).resize(function () {
                    initializeTooltip($target, $tooltip);
                });
                var removeTooltip = function() {
                    $tooltip.animate({ top: '-=10', opacity: 0 }, 50, function () {
                        $(this).remove();
                    });
                    $target.attr('title', tip);
                };
                $target.mouseleave(removeTooltip);
                $tooltip.click(removeTooltip);
            });
        });
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Tooltips werden anhand des data-tooltip Attributes erzeugt und hinzugefügt. Das data-tooltip Attribut wird    //
    // ebenfalls dynamisch hinzugefügt, durch die Angabe des Parameters tooltip in der jeweiligen Validation.xml.    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var tooltips = new Array();
    var parseDataTooltip = function () {

        $(SELECTOR_DATATOOLTIP).each(function (index, element) {
            var $target = false;
            var tip = false;

            var documentationIdentifier = null;
            var $container = $(element);
            var parentContainer = $(element).closest('div[class^="col-"]');

            documentationIdentifier = $container.attr('data-tooltip');
            $container.removeAttr(SELECTOR_DATATOOLTIP.replace('[', '').replace(']', ''));
            parentContainer.after('<span class="fa  fa-info-circle warning info-circle tip' + index + '"></span>');
            $target = $('.tip' + index);

            $target.mouseenter(function () {
                    if(documentationIdentifier in tooltips) {
                    showTooltip($target, tooltips[documentationIdentifier]);
                } else {
                    App.Interface.Api.get('documentation', {'id': documentationIdentifier}, {
                            key: 'e861968f-0380-4318-864f-d1deb81e0884'
                        },
                    function (responseObj) {
                        tip = responseObj.tooltip;
                        tooltips[documentationIdentifier] = tip;
                        showTooltip($target, tip);
                    },
                    function (responseObj) {
                        tip = "Es wurde für dieses Feld kein Tooltip hinterlegt.";
                        tooltips[documentationIdentifier] = tip;
                        showTooltip($target, tip);
                    });
                }
            });
        });
    };

    var showTooltip = function ($target, tip) {
        var $tooltip = false;
        $tooltip = $('<div class="tooltip"></div>');
        if (!tip || (tip === '')) return false;
        //$target.removeAttr('title');
        $tooltip.css('opacity', 0).html(tip).appendTo('body');
        initializeTooltip($target, $tooltip);
        $(window).resize(function () {
            initializeTooltip($target, $tooltip);
        });
        var removeTooltip = function() {
            $tooltip.animate({ top: '-=10', opacity: 0 }, 50, function () {
                $(this).remove();
            });
        };
        $target.mouseleave(removeTooltip);
        $tooltip.click(removeTooltip);
    };

    App.load(parseTooltip);
    App.load(parseDataTooltip);

});
